import { buildEqFilter, mergeFilters, type GridFilters } from '@/ui/composites/grid/gridFilters';

export const mergeProjectFilters = (
  filters: GridFilters,
  projectId?: string | null,
): GridFilters => {
  const hasProjectFilter = filters.some((filter) => filter.field === 'projectId');
  const projectFilters = !hasProjectFilter ? buildEqFilter('projectId', projectId ?? null) : [];
  return mergeFilters(projectFilters, filters);
};
